import React, { useCallback, useState } from 'react';
import type { ICellRendererParams } from 'ag-grid-community';

const CopyIcon = () => (
  <svg width={11} height={11} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="9" y="9" width="13" height="13" rx="2" />
    <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
  </svg>
);

const CheckIcon = () => (
  <svg width={11} height={11} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const CopyableCellRenderer: React.FC<ICellRendererParams> = ({ value, valueFormatted }) => {
  const [copied, setCopied] = useState(false);
  const display = valueFormatted ?? (value != null ? String(value) : '');

  const handleCopy = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    if (!display) return;
    navigator.clipboard?.writeText(display);
    setCopied(true);
    setTimeout(() => setCopied(false), 1100);
  }, [display]);

  if (!display) return null;

  return (
    <span className="sky-copyable-cell">
      <span className="sky-copyable-cell__text">{display}</span>
      <button
        className={`sky-copyable-cell__btn ${copied ? 'sky-copyable-cell__btn--copied' : ''}`}
        onClick={handleCopy}
        title={copied ? 'Copied!' : 'Copy'}
      >
        {copied ? <CheckIcon /> : <CopyIcon />}
      </button>
    </span>
  );
};
